/* global google */
import React, { Fragment } from "react";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
  Circle
} from "react-google-maps";

const Map = props => {
    return (
      <GoogleMap
        defaultZoom={props.zoom}
        center={props.center}
        onClick={props.onClick}
      >
        {props.places.map((place,index) => {
          return (
            <Fragment key={index}>
             {<Marker
                position={{
                  lat: parseFloat(place.latitude),
                  lng: parseFloat(place.longitude)
                }}
              />}
            </Fragment>
          );
        })}
      </GoogleMap>
    );
}

export default withScriptjs(withGoogleMap(Map));
